import LangKeys from "./keys";

const en = {
  [LangKeys.reminders_collect_faster]: "Collect Money 3x Faster",
  [LangKeys.reminders_total_dues]: "Total Dues",
  [LangKeys.reminders_all_customers]: "All Customers",
  [LangKeys.reminders_all]: "All",
  [LangKeys.reminders_customers]: "Customers",
  [LangKeys.reminders_suppliers]: "Suppliers",
  [LangKeys.reminders_search_placeholder]: "Search by customer name or mobile...",
  [LangKeys.reminders_pending_balance]: "Pending Balance",
  [LangKeys.reminders_sent]: "Sent",
  [LangKeys.reminders_whatsapp]: "WhatsApp",
  [LangKeys.reminders_sms]: "SMS",
  [LangKeys.reminders_call]: "Call",
  [LangKeys.reminders_date]: "Date",
  [LangKeys.reminders_all_up_to_date]: "All Up to Date",
  [LangKeys.reminders_no_overdue_heading]: "No overdue customers found",
  [LangKeys.reminders_no_overdue_sub]: "Great! All customer dues are currently up to date with no overdue payments.",
  [LangKeys.reminders_view_all_customers]: "View All Customers",
  [LangKeys.reminders_no_due_today_heading]: "No customers due today",
  [LangKeys.reminders_no_due_today_sub]: "No customer payment reminders are scheduled for today.",
  [LangKeys.reminders_no_upcoming_heading]: "No upcoming reminders",
  [LangKeys.reminders_no_upcoming_sub]: "Set collection dates for customers to send timely automated reminders.",
  [LangKeys.reminders_no_customers_found]: "No customers found",
  [LangKeys.reminders_no_customers_matched]: "No customers matched your search query.",
  [LangKeys.reminders_auto_reminder_active]: "Auto Reminder Active",
  [LangKeys.reminders_overdue_by]: "Overdue by",
  [LangKeys.reminders_due_in]: "Due in",
  [LangKeys.reminders_days]: "days",
  [LangKeys.reminders_day]: "day",
  [LangKeys.reminders_set_collection_date]: "Set Collection Date",
  [LangKeys.reminders_collect_faster_sub]: "Collect faster from customers",
  [LangKeys.reminders_pending_amount_filter]: "Pending Amount Filter (₹)",
  [LangKeys.reminders_highest_amount]: "Highest Amount",
  [LangKeys.reminders_oldest_dues]: "Oldest Dues",
  [LangKeys.reminders_by_due_date]: "By Due Date",
  [LangKeys.reminders_min]: "Min",
  [LangKeys.reminders_max]: "Max",
  [LangKeys.reminders_to]: "to",
  [LangKeys.reminders_customers_selected]: "Customers Selected",
  [LangKeys.reminders_total]: "Total",
  [LangKeys.reminders_set_due_date_selected]: "Set Due Date for Selected",
  [LangKeys.reminders_date_lbl]: "Date",
  [LangKeys.reminders_wa_sent_toast]: "WhatsApp reminder sent to {name}!",
  [LangKeys.reminders_date_updated]: "Reminder date saved successfully!",

  [LangKeys.reminders_bulk_success]: "Reminders sent successfully!",

  [LangKeys.reminders_sending]: "Saving...",

  [LangKeys.reminders_cloud_wa]: "Cloud WhatsApp API (Official SMS)",

  [LangKeys.reminders_direct_wa]: "Direct WhatsApp (Free Web/App)",

  [LangKeys.reminders_no_pending_desc]: "Customers with pending balances will appear here in the reminders list.",

  [LangKeys.reminders_no_pending]: "No Pending Reminders",

  [LangKeys.reminders_clear_date]: "Clear Date",

  [LangKeys.reminders_save_date]: "Save Date",

  [LangKeys.reminders_time_lbl]: "Time",

  [LangKeys.reminders_chip_custom]: "Custom Date",

  [LangKeys.reminders_chip_1month]: "In 1 Month",

  [LangKeys.reminders_chip_15days]: "In 15 Days",

  [LangKeys.reminders_chip_1week]: "In 1 Week",

  [LangKeys.reminders_chip_3days]: "In 3 Days",

  [LangKeys.reminders_chip_tomorrow]: "Tomorrow",

  [LangKeys.reminders_chip_today]: "Today",

  [LangKeys.reminders_days_left]: "days left",

  [LangKeys.reminders_days_overdue]: "days overdue",

  [LangKeys.reminders_not_sent]: "Not sent yet",

  [LangKeys.reminders_last_sent]: "Last sent",

  [LangKeys.reminders_auto_reminder_desc]: "Automatically send reminder on scheduled date & time",

  [LangKeys.reminders_auto_reminder]: "Auto Reminder (Auto Send)",

  [LangKeys.reminders_send_all_whatsapp]: "Send WhatsApp to All",

  [LangKeys.reminders_send_whatsapp]: "Send WhatsApp Reminder",

  [LangKeys.reminders_change_due_date]: "Change Due Date",

  [LangKeys.reminders_set_due_date]: "Set Due Date",

  [LangKeys.reminders_selected]: "Selected",

  [LangKeys.reminders_select_all]: "Select All",

  [LangKeys.reminders_search_hint]: "Search customer name or mobile...",

  [LangKeys.reminders_no_date_tab]: "No Date",

  [LangKeys.reminders_upcoming_tab]: "Upcoming",

  [LangKeys.reminders_overdue_tab]: "Overdue",

  [LangKeys.reminders_today_tab]: "Due Today",

  [LangKeys.reminders_all_tab]: "All",

  [LangKeys.reminders_no_date]: "No Date Set",

  [LangKeys.reminders_upcoming]: "Upcoming",

  [LangKeys.reminders_due_today]: "Due Today",

  [LangKeys.reminders_overdue]: "Overdue",

  [LangKeys.reminders_total_outstanding]: "Total Outstanding",

  [LangKeys.reminders_subtitle]: "Grow your business with smarter bookkeeping.",

  [LangKeys.reminders_title]: "Payment Reminder",

  [LangKeys.processing]: "Processing...",

  [LangKeys.business_owner]: "Business Owner",

  [LangKeys.moxpal_khata]: "Moxpal Khata",

  [LangKeys.failed_load_dashboard]: "Failed to load dashboard data",

  [LangKeys.delete_confirm]: "Are you sure you want to delete?",

  [LangKeys.today]: "Today",

  [LangKeys.add_bill_terms_conditions_hint]: "Terms and Conditions...",

  [LangKeys.stock]: "Stock",

  [LangKeys.add_bill_item_price]: "Price",

  [LangKeys.add_bill_item_name]: "Item Name",

  [LangKeys.parties]: "Parties",

  [LangKeys.address_area]: "Area / Landmark",

  [LangKeys.address_flat_no]: "Flat / Building No.",

  [LangKeys.search_items_hint]: "Search items...",

  [LangKeys.no_items_found]: "No items found",

  [LangKeys.loading]: "Loading...",

  [LangKeys.edit_price_dialog_title]: "Edit Price",

  [LangKeys.photos]: "Photos",

  [LangKeys.notes]: "Notes",

  [LangKeys.save_expense]: "Save Expense",

  [LangKeys.add_bill_payment_details]: "Payment Details",

  [LangKeys.fields]: "Fields",

  [LangKeys.unpaid]: "Unpaid",

  [LangKeys.item_name_required]: "Item name is required",

  [LangKeys.delete_confirmation]: "Are you sure you want to delete this?",

  [LangKeys.online_private]: "Private",

  [LangKeys.online_active]: "Online in Market",

  [LangKeys.app_name]: "Moxpal Khata",

  [LangKeys.header_subtitle]: "Grow your business with smarter bookkeeping.",

  // SHARED KHATA
  [LangKeys.shared_khata__summary]: "Khata Summary",
  [LangKeys.customer_name]: "Customer Name",
  [LangKeys.mobile_no]: "Mobile No",
  [LangKeys.transaction_history]: "Transaction History",
  [LangKeys.total_debit]: "Total Debit",
  [LangKeys.total_credit]: "Total Credit",
  [LangKeys.net_balance]: "Net Balance",
  [LangKeys.date]: "Date",
  [LangKeys.credit]: "Credit",
  [LangKeys.debit]: "Dr",
  [LangKeys.balance]: "Balance",
  [LangKeys.note]: "Note",
  [LangKeys.call_support]: "Call Support",
  [LangKeys.invalid_link]: "This link is invalid or has expired.",
  [LangKeys.footer]: "This is a computer generated statement and does not require any signature.",

  // COMMON
  [LangKeys.settings]: "Settings",
  [LangKeys.settings_subtitle]: "Manage your application and business preferences",
  [LangKeys.language]: "Language",
  [LangKeys.select_language]: "Select Language",
  [LangKeys.close]: "Close",
  [LangKeys.save]: "Save",
  [LangKeys.retry]: "Retry",
  [LangKeys.profile]: "Edit Profile",
  [LangKeys.logout]: "Logout",
  [LangKeys.version]: "Version",
  [LangKeys.copyright]: "Copyright © Moxpal Khata",
  [LangKeys.total]: "Total",
  [LangKeys.required_field]: "This field is required",
  [LangKeys.product]: "Product",
  [LangKeys.message_language]: "SMS Language",
  [LangKeys.follow_app]: "Follow App",
  [LangKeys.hindi]: "Hindi",
  [LangKeys.english]: "English",
  [LangKeys.hinglish]: "Hinglish",
  [LangKeys.gujarati]: "Gujarati",
  [LangKeys.marathi]: "Marathi",
  [LangKeys.punjabi]: "Punjabi",
  [LangKeys.tamil]: "Tamil",
  [LangKeys.telugu]: "Telugu",

  // SETTINGS PAGE
  [LangKeys.business_settings]: "Business Settings",
  [LangKeys.business_settings_desc]: "Business profile, logo & GST details",
  [LangKeys.staff_permissions]: "Staff & Permissions",
  [LangKeys.staff_permissions_desc]: "Manage staff access and permissions",
  [LangKeys.backup_information]: "Backup Information",
  [LangKeys.backup_information_desc]: "Export and restore khata data",
  [LangKeys.delete_khata]: "Delete Khata",
  [LangKeys.delete_khata_desc]: "Permanently remove all business data",
  [LangKeys.app_update]: "App Update",
  [LangKeys.app_update_desc]: "Check for latest version",
  [LangKeys.app_up_to_date]: "App is up to date",
  [LangKeys.failed_to_check_for_update]: "Failed to check for updates",
  [LangKeys.whatsapp_service]: "WhatsApp Alerts & Credits",
  [LangKeys.whatsapp_service_desc]: "Send automatic payment reminders & manage credits",

  // Whatsapp SMS Credtits PAGE
  [LangKeys.whatsapp_credits]: "WhatsApp Credits",
  [LangKeys.available_credits]: "Available Credits",
  [LangKeys.whatsapp_balance]: "WhatsApp message balance",
  [LangKeys.used]: "Used",
  [LangKeys.credits]: "Credits",
  [LangKeys.proceed_to_pay]: "Proceed to Pay",
  [LangKeys.recharge_plans]: "Recharge Plans",
  [LangKeys.off]: "OFF",
  [LangKeys.premium_unlimited_active]: "Unlimited WhatsApp alerts are active! 🎉",
  [LangKeys.premium_unlimited_desc]: "You are an active member of Moxpal Khata's best plan 'Premium Plan 98'! You have been given unlimited auto WhatsApp and SMS alerts completely free.",
  [LangKeys.load_failed]: "Load failed",
  [LangKeys.toggle_failed]: "Toggle failed",
  [LangKeys.order_failed]: "Order failed",
  [LangKeys.payment_error]: "Payment error",
  [LangKeys.payment_failed]: "Payment failed",
  [LangKeys.verification_failed]: "Verification failed",
  [LangKeys.recharge_successful]: "Recharge successful",
  [LangKeys.total_purchased]: "Total Purchased",

  // BACKUP INFORMATION
  [LangKeys.backup_info_text]: "Your data is automatically backed up when your phone is connected to the internet. If you format your phone or delete the app, just log in again using your registered number. Your data will be restored automatically.",
  [LangKeys.last_backup_at]: "LAST BACKUP AT",

  // DELETE / KHATA
  [LangKeys.delete_warning_text]: "You are going to delete this business. All your data will be moved to recycle bin. You can restore it within 30 days.",
  [LangKeys.delete_placeholder]: "Type business name to confirm",
  [LangKeys.delete_button]: "DELETE",
  [LangKeys.delete_name_mismatch]: "Business name does not match.",

  // KHATA
  [LangKeys.my_khata]: "My Khata",
  [LangKeys.search_customer]: "Search Customer",
  [LangKeys.all_customers]: "All Customers",
  [LangKeys.no_customers_found]: "No customers found",
  [LangKeys.no_suppliers_found]: "No suppliers found",
  [LangKeys.no_parties_found]: "No parties found",
  [LangKeys.just_now]: "Just now",
  [LangKeys.min_ago]: "{value} min ago",
  [LangKeys.hr_ago]: "{value} hr ago",
  [LangKeys.day_ago]: "{value} day ago",
  [LangKeys.month_ago]: "{value} month ago",
  [LangKeys.year_ago]: "{value} year ago",
  [LangKeys.settled]: "Settled",
  [LangKeys.advance]: "Advance",
  [LangKeys.due]: "Due",
  [LangKeys.no_entries_yet]: "No entries yet",
  [LangKeys.new_label]: "New",
  [LangKeys.no_transactions]: "No Transactions",


  // DASHBOARD / HOME SCREEN
  [LangKeys.khata]: "Ledger",
  [LangKeys.you_will_get]: "You Will Get",
  [LangKeys.you_will_give]: "You Will Give",
  [LangKeys.search_khata_entry]: "Search Entry",
  [LangKeys.recent_entries]: "Recent Entries",
  [LangKeys.unknown_party]: "Unknown Party",
  [LangKeys.unknown_customer]: "Unknown Customer",
  [LangKeys.unknown]: "Unknown",

  // CUSTOMER LEDGER
  [LangKeys.ledger]: "Ledger",
  [LangKeys.report]: "Report",
  [LangKeys.reminder]: "Reminder",
  [LangKeys.sms]: "SMS",
  [LangKeys.whatsapp]: "Whatsapp",
  [LangKeys.outstanding_balance]: "Outstanding Balance",
  [LangKeys.total_balance]: "Total Balance",
  [LangKeys.you_got]: "You Got",
  [LangKeys.you_gave]: "You Gave",
  [LangKeys.entries]: "Entries",
  [LangKeys.no_entries_found]: "No entries found",
  [LangKeys.i_got]: "I Got",
  [LangKeys.i_gave]: "I Gave",
  [LangKeys.you_got_caps]: "YOU GOT",
  [LangKeys.you_gave_caps]: "YOU GAVE",
  [LangKeys.wa_dear]: "Dear",
  [LangKeys.wa_account_update]: "here is your account update from Moxpal Khata.",
  [LangKeys.total_due]: "Total Balance Due",
  [LangKeys.view_full_account]: "View Full Account Statement",
  [LangKeys.failed_to_load_data]: "Failed to load data.",
  [LangKeys.could_not_open_whatsapp]: "Could not open WhatsApp.",
  [LangKeys.could_not_open_sms]: "Could not open SMS app.",
  [LangKeys.total_purchase]: "Total Purchase",
  [LangKeys.total_received]: "Total Received",
  [LangKeys.entry_success]: "Entry Successful",
  [LangKeys.transaction_success]: "Transaction Successful",
  [LangKeys.done]: "Done",

  // ENTRY
  [LangKeys.entry_details]: "Entry Details",
  [LangKeys.running_balance]: "Running Balance",
  [LangKeys.share]: "Share",
  [LangKeys.network_error]: "Network Error",
  [LangKeys.copy_link]: "Copy Link",
  [LangKeys.delete_entry]: "Delete Entry",
  [LangKeys.delete_entry_confirm]: "Are you sure you want to delete this entry?",
  [LangKeys.delete_entry_warning]: "This action cannot be undone.",
  [LangKeys.edit_entry]: "Edit Entry",
  [LangKeys.invalid_entry]: "Invalid Entry",
  [LangKeys.entry_not_found]: "Entry not found",
  [LangKeys.invalid_entry_type]: "Invalid entry type",
  [LangKeys.invalid_amount]: "Invalid amount",
  [LangKeys.invalid_date]: "Invalid date",
  [LangKeys.photo_size_error]: "Photo size should be less than 1MB",
  [LangKeys.invalid_image_format]: "Invalid format. Please upload JPG, PNG or WEBP image.",
  [LangKeys.photo_upload_failed]: "Photo upload failed",
  [LangKeys.update_failed]: "Update failed",
  [LangKeys.amount]: "Amount",
  [LangKeys.photo_max]: "Photo (Max 1MB)",
  [LangKeys.change_photo]: "Change Photo",
  [LangKeys.add_entry_title]: "Add Entry",
  [LangKeys.save_entry]: "Save Entry",
  [LangKeys.photo]: "Photo",
  [LangKeys.amount_hint]: "₹ 0",
  [LangKeys.note_hint]: "Optional note",
  [LangKeys.add_photo_label]: "📷 Add Photo",
  [LangKeys.failed_to_add_entry]: "Failed to add entry.",
  [LangKeys.image_too_large_4mb]: "Image is too large. Please select an image under 4MB.",
  [LangKeys.share_coming_soon]: "Share feature coming soon!",
  [LangKeys.image_load_failed]: "Failed to load image",
  [LangKeys.select_date]: "Select Date",
  [LangKeys.photo_max_2mb]: "Photo (Max 2MB)",
  [LangKeys.add_to_cashbook]: "Add to Cashbook too",

  // PDF
  [LangKeys.owner_name]: "Owner Name",
  [LangKeys.customer_ledger_statement]: "Customer Ledger Statement",
  [LangKeys.supplier_ledger_statement]: "Supplier Ledger Statement",
  [LangKeys.phone]: "Phone",
  [LangKeys.opening_balance]: "Opening Balance",
  [LangKeys.closing_balance]: "Closing Balance",
  [LangKeys.transaction_details]: "Transaction Details",
  [LangKeys.particulars]: "Particulars",
  [LangKeys.credit_short]: "Cr",
  [LangKeys.debit_short]: "Dr",
  [LangKeys.generated_by]: "Generated by Moxpal Khata",
  [LangKeys.my_business]: "My Business",
  [LangKeys.pdf_generation_error]: "Error generating PDF",
  [LangKeys.debit_minus]: "Debit (-)",
  [LangKeys.credit_plus]: "Credit (+)",
  [LangKeys.total_paid]: "Total Paid",
  [LangKeys.received]: "Received",
  [LangKeys.paid]: "Paid",
  [LangKeys.supplier_name]: "Supplier Name",
  [LangKeys.supplier_report]: "Supplier Report",
  [LangKeys.data_not_available_for_pdf]: "Data not available for PDF",
  [LangKeys.customer_report]: "Customer Report",
  [LangKeys.print_download]: "Print / Download",
  [LangKeys.total_get]: "Total Get",
  [LangKeys.total_give]: "Total Give",
  [LangKeys.report_for]: "Report For",
  [LangKeys.period]: "Period",
  [LangKeys.report_generated_by]: "Report generated by {app}",
  [LangKeys.all_time]: "All Time",
  [LangKeys.get]: "Get",
  [LangKeys.give]: "Give",

  // ACCOUNT
  [LangKeys.account]: "Account",
  [LangKeys.add_business]: "Add Business Details",
  [LangKeys.add_owner]: "Add Owner Details",
  [LangKeys.business]: "Business",
  [LangKeys.staff]: "Staff",
  [LangKeys.items]: "Items",
  [LangKeys.bills]: "Bills",
  [LangKeys.dairy]: "Dairy",
  [LangKeys.cashbook]: "Cashbook",
  [LangKeys.help_support]: "Help & Support",
  [LangKeys.about_app]: "About Us",
  [LangKeys.invite_friends]: "Invite Friends",
  [LangKeys.privacy_policy]: "Privacy Policy",
  [LangKeys.disclaimer]: "Disclaimer",
  [LangKeys.share_subject]: "📒 Moxpal Khata App",
  [LangKeys.share_message]: "👉 I am using the Moxpal Khata app to manage credit and transaction records. It is very simple and reliable. 📲 You can also download it now and easily manage your accounts: https://khata.moxpal.com/app",

  // STAFF
  [LangKeys.staff_details]: "Staff Details",
  [LangKeys.staff_question]: "What is a staff?",
  [LangKeys.add_staff]: "Add Staff",
  [LangKeys.staff_name]: "Staff Name",
  [LangKeys.permissions]: "Permissions",
  [LangKeys.stop_staff]: "Stop Staff",
  [LangKeys.stop_staff_desc]: "This staff will not be able to access your business data.",
  [LangKeys.delete_staff]: "Delete Staff",
  [LangKeys.delete_staff_desc]: "This staff will be permanently deleted.",
  [LangKeys.add_staff_to_manage]: "Add staff to manage",

  // NAVBAR
  [LangKeys.home]: "Home",
  [LangKeys.more]: "More",

  // ADD PARTY
  [LangKeys.add_party]: "Add Party",
  [LangKeys.address_optional]: "Address (Optional)",
  [LangKeys.gst_optional]: "GSTIN (Optional)",
  [LangKeys.add_supplier]: "Add Supplier",
  [LangKeys.name_required]: "Name is required",
  [LangKeys.edit]: "Edit",

  // BOOK PROFILE
  [LangKeys.book_profile]: "Book Profile",
  [LangKeys.personal_info]: "Personal Info",
  [LangKeys.business_info]: "Business Info",
  [LangKeys.financial_info]: "Financial Info",
  [LangKeys.staff_info]: "Staff Info",
  [LangKeys.name]: "Name",
  [LangKeys.add_name]: "Add Name",
  [LangKeys.registered_number]: "Registered Mobile Number",
  [LangKeys.add_mobile]: "Add Mobile Number",
  [LangKeys.business_name]: "Business Name",
  [LangKeys.business_address]: "Business Address",
  [LangKeys.add_address]: "Add Address",
  [LangKeys.gstin]: "GSTIN",
  [LangKeys.bank_account]: "Bank Account",
  [LangKeys.add_details]: "Add Details",
  [LangKeys.details]: "Details",
  [LangKeys.add_photo]: "Add Photo",
  [LangKeys.profile_strength]: "Profile Strength",
  [LangKeys.customer_profile]: "Customer Profile",
  [LangKeys.supplier_profile]: "Supplier Profile",
  [LangKeys.address]: "Address",
  [LangKeys.type]: "Type",
  [LangKeys.customer]: "Customer",
  [LangKeys.supplier]: "Supplier",
  [LangKeys.delete_customer]: "Delete Customer",
  [LangKeys.delete_supplier]: "Delete Supplier",
  [LangKeys.delete_customer_desc]: "Are you sure you want to delete this customer? All related data will be removed.",
  [LangKeys.delete_supplier_desc]: "Are you sure you want to delete this supplier? All related data will be removed.",
  [LangKeys.add_gstin]: "Add GSTIN",

  // SMS SETTINGS
  [LangKeys.sms_settings]: "SMS Settings",
  [LangKeys.sms_settings_desc]: "Manage message settings for this customer",
  [LangKeys.edit_customer_details]: "Edit Customer Details",
  [LangKeys.edit_customer_details_desc]: "You can edit customer details like name, mobile, address and GST here.",

  // PROFILE STRENGTH
  [LangKeys.weak]: "Weak",
  [LangKeys.average]: "Average",
  [LangKeys.good]: "Good",
  [LangKeys.strong]: "Strong",

  // STAFF & PERMISSIONS
  [LangKeys.save_staff]: "Save Staff",
  [LangKeys.update_staff]: "Update Staff",
  [LangKeys.cancel]: "Cancel",
  [LangKeys.no_staff_found]: "No staff found",
  [LangKeys.active]: "Active",
  [LangKeys.stopped]: "Stopped",
  [LangKeys.start]: "Start",
  [LangKeys.stop]: "Stop",
  [LangKeys.view]: "View",
  [LangKeys.add]: "Add",
  [LangKeys.delete]: "Delete",
  [LangKeys.mobile_number]: "Mobile Number",
  [LangKeys.add_staff_title]: "Add Staff",
  [LangKeys.edit_staff_title]: "Edit Staff",
  [LangKeys.staff_deleted_success]: "Staff deleted successfully",
  [LangKeys.yes]: "Yes",
  [LangKeys.no]: "No",
  [LangKeys.khatabook_deleted_success]: "Khatabook deleted successfully",
  [LangKeys.something_went_wrong]: "Something went wrong",
  [LangKeys.business_logo]: "Business Logo",
  [LangKeys.choose_photo]: "Choose Photo",
  [LangKeys.save_logo]: "Save Logo",
  [LangKeys.upload_error]: "Upload Error",
  [LangKeys.upload_type_err]: "Upload type error",
  [LangKeys.enter_name]: "Enter Name",
  [LangKeys.enter_mobile]: "Enter Mobile",
  [LangKeys.enter_business]: "Enter Business",
  [LangKeys.enter_address]: "Enter Address",
  [LangKeys.gstin_details]: "GSTIN Details",
  [LangKeys.gstin_number]: "GSTIN Number",
  [LangKeys.enter_gstin]: "Enter GSTIN",
  [LangKeys.gstin_note]: "Your GSTIN is used to verify your business and to generate invoices.",
  [LangKeys.save_gstin]: "Save GSTIN",
  [LangKeys.bank_details]: "Bank Details",
  [LangKeys.bank_name]: "Bank Name",
  [LangKeys.enter_bank_name]: "Enter Bank Name",
  [LangKeys.account_number]: "Account Number",
  [LangKeys.enter_account_no]: "Enter Account Number",
  [LangKeys.ifsc_code]: "IFSC Code",
  [LangKeys.enter_ifsc]: "Enter IFSC Code",
  [LangKeys.bank_note]: "Your bank account is used to receive payments.",
  [LangKeys.save_bank_details]: "Save Bank Details",
  [LangKeys.invalid_bank_details]: "Invalid bank details",
  [LangKeys.confirm]: "Confirm",
  [LangKeys.invalid_gstin]: "Invalid GSTIN",
  [LangKeys.failed_to_save]: "Failed to save",

  // Cashbook
  [LangKeys.cash]: "Cash",
  [LangKeys.online]: "Online",
  [LangKeys.total_balance_cashbook]: "Total Balance",
  [LangKeys.today_balance]: "Today Balance",
  [LangKeys.view_report]: "View Report",
  [LangKeys.out_entry]: "OUT",
  [LangKeys.in_entry]: "IN",
  [LangKeys.add_first_entry]: "Add your first entry",
  [LangKeys.attach_bill]: "Attach Bill",
  [LangKeys.enter_amount]: "Enter amount",
  [LangKeys.empty_title]: "No entries yet",
  [LangKeys.saving]: "Saving...",
  [LangKeys.save_failed]: "Failed to save",
  [LangKeys.server_error]: "Server Error",
  [LangKeys.ok]: "OK",
  [LangKeys.error]: "Error",
  [LangKeys.payment_mode]: "Payment Mode",
  [LangKeys.entry_saved_offline_and_will_be_synced_later]: "Entry saved offline. It will sync when internet is available",
  [LangKeys.entry_waiting_to_be_synced]: "Entry saved offline. Sync pending",
  [LangKeys.cash_entry]: "Cash Entry",
  [LangKeys.cash_in]: "Money Added",
  [LangKeys.cash_out]: "Money Spent",
  [LangKeys.cashbook_status]: "Cashbook Status",
  [LangKeys.real_time_cash_online]: "Real-time Cash & Online",

  // Cashbook Specific
  [LangKeys.entry_is_backed_up]: "Entry is backed up",
  [LangKeys.safe_and_secure]: "100% Safe and Secure",
  [LangKeys.invalid_image_format_cashbook_popup]: "Unsupported format. Please use JPG, PNG, or WEBP.",
  [LangKeys.photo_size_error_cashbook_popup]: "File is too large (Max 4MB)",
  [LangKeys.selected_image]: "Selected",

  // Cashbook Report Screen
  [LangKeys.cashbook_report_title]: "Cashbook Report",
  [LangKeys.date_range]: "Date Range",
  [LangKeys.single_day]: "Single Day",
  [LangKeys.this_week]: "This Week",
  [LangKeys.this_month]: "This Month",
  [LangKeys.last_week]: "Last Week",
  [LangKeys.last_month]: "Last Month",
  [LangKeys.all]: "All",
  [LangKeys.to]: "to",
  [LangKeys.no_entries_found_period]: "No entries found in this period.",
  [LangKeys.daily_balance_short]: "Daily Balance",
  [LangKeys.download_pdf]: "DOWNLOAD PDF",
  [LangKeys.pdf_download_not_implemented]: "PDF Download not implemented yet.",

  // Cashbook Report Day Screen
  [LangKeys.daily_details]: "Daily Details",
  [LangKeys.no_entries_on_this_day]: "No entries on this day",
  [LangKeys.add_entries_help]: "Add entries to see them here.",
  [LangKeys.add_entry_to]: "Add Entry to",
  [LangKeys.add_entry]: "Add Entry",
  [LangKeys.could_not_load_report]: "Could not load report.",

  // Entry Details Screen
  [LangKeys.delete_failed]: "Delete failed",
  [LangKeys.photo_max_4mb]: "Photo (Max 4MB)",
  [LangKeys.entry_of_amount]: "Entry of ",

  // PDF CASHBOOK REPORT
  [LangKeys.daily_summary]: "Daily Summary",
  [LangKeys.total_in]: "Total In",
  [LangKeys.total_out]: "Total Out",
  [LangKeys.no_data_available]: "No data available",

  // Months
  [LangKeys.month_1]: "Jan",
  [LangKeys.month_2]: "Feb",
  [LangKeys.month_3]: "Mar",
  [LangKeys.month_4]: "Apr",
  [LangKeys.month_5]: "May",
  [LangKeys.month_6]: "Jun",
  [LangKeys.month_7]: "Jul",
  [LangKeys.month_8]: "Aug",
  [LangKeys.month_9]: "Sep",
  [LangKeys.month_10]: "Oct",
  [LangKeys.month_11]: "Nov",
  [LangKeys.month_12]: "Dec",

  // Customer Supplier Add
  [LangKeys.add_customer]: "Add Customer",
  [LangKeys.customer_already_exists]: "Customer already exists",
  [LangKeys.supplier_already_exists]: "Supplier already exists",

  // Cashbook Empty State
  [LangKeys.cashbook_welcome]: "Hello! Let's make today's entries",
  [LangKeys.add_first_entry_btn]: "Add Your First Entry",
  [LangKeys.add_customers_collect_faster]: "Add customers & collect payments faster",

  // Permissions
  [LangKeys.permission_denied_title]: "Permission Denied",
  [LangKeys.permission_denied_content]: "Photo access is permanently denied. Please go to app settings to enable it.",
  [LangKeys.permission_denied_settings_button]: "Open Settings",
  [LangKeys.permission_denied_cancel_button]: "Cancel",
  [LangKeys.permission_denied_generic_message]: "Permission denied. Please allow photo access to select a photo.",

  // Contact Picker
  [LangKeys.permission_required]: "Permission Required",
  [LangKeys.contacts_permission_message]: "Contacts permission is required to pick a contact. Please enable it in app settings.",
  [LangKeys.failed_to_open_contacts_picker]: "Failed to open contacts picker.",
  [LangKeys.permission_denied_to_read_contacts]: "Permission denied to read contacts.",

  // Add Item Screen
  [LangKeys.tax_exempted]: "Tax Exempted",
  [LangKeys.no_gst]: "No GST",
  [LangKeys.select_photo]: "Select Photo",
  [LangKeys.gallery]: "Gallery",
  [LangKeys.camera]: "Camera",
  [LangKeys.please_enter_item_name]: "Please enter item name",
  [LangKeys.failed_to_upload_image]: "Failed to upload image",
  [LangKeys.item_updated_successfully]: "Item updated successfully",
  [LangKeys.item_saved_successfully]: "Item saved successfully",
  [LangKeys.failed_to_update_item]: "Failed to update item",
  [LangKeys.failed_to_save_item]: "Failed to save item",
  [LangKeys.confirm_deletion]: "Confirm Deletion",
  [LangKeys.are_you_sure_delete_item]: "Are you sure you want to delete this item?",
  [LangKeys.item_deleted_successfully]: "Item deleted successfully",
  [LangKeys.failed_to_delete_item]: "Failed to delete item",
  [LangKeys.edit_item]: "Edit Item",
  [LangKeys.edit_service]: "Edit Service",
  [LangKeys.add_product]: "Add Product",
  [LangKeys.add_service]: "Add Service",
  [LangKeys.add_hsn_and_gst_details]: "Add HSN & GST Details",
  [LangKeys.hsn]: "HSN",
  [LangKeys.enter_hsn]: "Enter HSN",
  [LangKeys.gst_rate_percent]: "GST Rate (%)",
  [LangKeys.enter_gst_rate]: "Enter GST rate",
  [LangKeys.primary_unit]: "Primary Unit",
  [LangKeys.enter_item_name_here]: "Enter item name here",
  [LangKeys.sale_price]: "Sale Price",
  [LangKeys.purchase_price]: "Purchase Price",
  [LangKeys.tax_included]: "Tax Included",
  [LangKeys.opening_stock]: "Opening Stock",
  [LangKeys.low_stock_alert]: "Low Stock Alert",
  [LangKeys.as_of_date]: "As of Date",
  [LangKeys.enter_price]: "Enter price",
  [LangKeys.enter_count]: "Enter quantity",
  [LangKeys.save_item]: "Save Item",
  [LangKeys.delete_item]: "Delete Item",
  [LangKeys.select_unit]: "Select Unit",
  [LangKeys.search_unit]: "Search Unit",
  [LangKeys.add_gst_rate]: "Add GST Rate",
  [LangKeys.add_custom_tax]: "Add Custom Tax",
  [LangKeys.custom_tax]: "Custom Tax",
  [LangKeys.gst]: "GST",
  [LangKeys.cess]: "Cess",
  [LangKeys.add_hsn_code]: "Add HSN Code",
  [LangKeys.hsn_code]: "HSN Code",
  [LangKeys.item_name]: "Item Name",
  [LangKeys.enter_hsn_code]: "Enter HSN code",
  [LangKeys.enter_item_name]: "Enter item name",
  [LangKeys.results]: "Results",
  [LangKeys.no_hsn_code_found]: "No HSN code found",
  [LangKeys.use]: "Use",
  [LangKeys.as_hsn_code]: "as HSN code",
  [LangKeys.you_are_offline_please_connect_to_the_internet]: "You are offline. Please connect to the internet.",

  // ITEMS SCREEN
  [LangKeys.products]: "Products",
  [LangKeys.services]: "Services",
  [LangKeys.add_product_caps]: "ADD PRODUCT",
  [LangKeys.add_service_caps]: "ADD SERVICE",
  [LangKeys.add_items_and_get_started]: "Start Managing Your Inventory",
  [LangKeys.manage_stock_feature]: "Smart stock control for your business",
  [LangKeys.detailed_stock_history_feature]: "Access complete item activity records",
  [LangKeys.track_prices_and_profits_feature]: "Monitor pricing and profit margins easily",
  [LangKeys.search_items]: "Search items",
  [LangKeys.my_items]: "My Items",
  [LangKeys.item_added]: "Item Added",
  [LangKeys.low_stock]: "Low Stock",
  [LangKeys.current_stock]: "Current Stock",
  [LangKeys.stock_history]: "Stock History",
  [LangKeys.stock_in]: "IN",
  [LangKeys.stock_out]: "OUT",
  [LangKeys.add_services_and_get_started]: "Start Managing Your Services",
  [LangKeys.manage_services_feature]: "Organize and manage all your service offerings",
  [LangKeys.save_sac_and_gst_feature]: "Save SAC codes and GST details easily",
  [LangKeys.track_sales_and_bills_feature]: "Track service sales and billing records",
  [LangKeys.net_monthly_sales]: "Net Monthly Sales",
  [LangKeys.rupees]: "Rupees",
  [LangKeys.search_services]: "Search services",
  [LangKeys.my_services]: "My Services",
  [LangKeys.service_price]: "Service Price",
  [LangKeys.unit]: "Unit",
  [LangKeys.enter_purchased_quantity]: "Enter purchased quantity",
  [LangKeys.enter_sold_quantity]: "Enter sold quantity",
  [LangKeys.quantity]: "Quantity",
  [LangKeys.add_notes_optional]: "Add notes (optional)",
  [LangKeys.stock_in_caps]: "STOCK IN",
  [LangKeys.stock_out_caps]: "STOCK OUT",
  [LangKeys.total_stock]: "Total Stock",
  [LangKeys.low_stock_items]: "Low Stock Items",
  [LangKeys.all_items]: "All Items",
  [LangKeys.not_available]: "0",
  [LangKeys.failed_to_load_items]: "Failed to load items",



  // ================= ITEMS SALES REPORT SCREEN =================
  [LangKeys.item_sales_report]: "Item Sales Report",
  [LangKeys.total_qty_sold]: "Total Qty Sold",
  [LangKeys.units]: "Units",
  [LangKeys.nos]: "NOS",
  [LangKeys.sold]: "Sold",
  [LangKeys.bought]: "Bought",
  [LangKeys.profit]: "Profit",
  [LangKeys.loss]: "Loss",

  // Filter & Sort
  [LangKeys.filter_by_stock]: "Filter by Stock",
  [LangKeys.sort_by_name_az]: "Sort by Name (A–Z)",
  [LangKeys.sort_by_name_za]: "Sort by Name (Z–A)",

  // ADD SERVICE SCREEN
  [LangKeys.failed_to_process_image]: "Failed to process image",
  [LangKeys.could_not_pick_image]: "Could not pick image",
  [LangKeys.failed_to_upload_photo]: "Failed to upload photo",
  [LangKeys.failed_to_update_service]: "Failed to update service",
  [LangKeys.failed_to_add_service]: "Failed to add service",
  [LangKeys.are_you_sure_delete_service]: "Are you sure you want to delete this service?",
  [LangKeys.failed_to_delete_service]: "Failed to delete service",
  [LangKeys.add_sac_and_gst_details]: "Add SAC & GST Details",
  [LangKeys.sac_code]: "SAC Code",
  [LangKeys.enter_sac]: "Enter SAC",
  [LangKeys.enter_service_name_here]: "Enter service name here",
  [LangKeys.please_enter_service_name]: "Please enter service name",
  [LangKeys.tax_included_in_price]: "Tax included in price",
  [LangKeys.delete_service]: "Delete Service",
  [LangKeys.save_changes]: "Save Changes",

  // ITEM DETAILS SCREEN
  [LangKeys.edit_product]: "Edit Product",
  [LangKeys.stock_quantity]: "Stock Quantity",
  [LangKeys.stock_value]: "Stock Value",

  // SERVICE DETAILS SCREEN
  [LangKeys.edit_service_caps]: "EDIT SERVICE",
  [LangKeys.service_name]: "Service Name",
  [LangKeys.gst_percent]: "GST %",
  [LangKeys.no_sales_added_for_service]: "No sales added for this service",
  [LangKeys.zero_percent]: "0%",

  // BILLS SCREEN
  [LangKeys.bills_add_sale]: "Add Sale",
  [LangKeys.bills_search_sales_hint]: "Search sales",
  [LangKeys.bills_add_purchase]: "Add Purchase",
  [LangKeys.bills_search_purchases_hint]: "Search purchases",
  [LangKeys.bills_add_expense]: "Add Expense",
  [LangKeys.bills_search_expenses_hint]: "Search expenses",
  [LangKeys.bills_start_creating_gst]: "Start creating GST bills",
  [LangKeys.bills_tab_sale]: "Sale",
  [LangKeys.bills_tab_purchase]: "Purchase",
  [LangKeys.bills_tab_expense]: "Expense",
  [LangKeys.bills_monthly_sales]: "Monthly Sales",
  [LangKeys.bills_monthly_purchases]: "Monthly Purchases",
  [LangKeys.bills_view_reports]: "View Reports",
  [LangKeys.bills_todays_in]: "Today's In",
  [LangKeys.bills_todays_out]: "Today's Out",
  [LangKeys.bills_cashbook]: "Cashbook",
  [LangKeys.bills_empty_state_title]: "Generate Professional Invoices Instantly",
  [LangKeys.bills_empty_state_subtitle]: "Automatically Updates Ledger, Stock & Cashbook",
  [LangKeys.bills_empty_state_gst_support]: "Supports Both GST & Non-GST Billing",
  [LangKeys.bills_see_sample_invoices]: "See sample invoices",
  [LangKeys.bills_no_matching_found]: "No matching bills found",
  [LangKeys.bills_payment_in]: "Payment In",
  [LangKeys.bills_status_fully_paid]: "Fully Paid",
  [LangKeys.bills_status_unpaid]: "Unpaid",
  [LangKeys.bills_sale_bill]: "Sale Bill",
  [LangKeys.bills_purchase_bill]: "Purchase Bill",
  [LangKeys.bills_expense_bill]: "Expense",
  [LangKeys.bills_more_button]: "More",
  [LangKeys.bills_added_to_ledger]: "✓ In Ledger",

  // FILTER & SORT
  [LangKeys.filter_and_sort]: "Filter & Sort",
  [LangKeys.filter_by_status]: "Filter by Status",
  [LangKeys.filter_all_bills]: "All Bills",
  [LangKeys.filter_paid_bills]: "Paid Bills",
  [LangKeys.filter_unpaid_bills]: "Unpaid Bills",
  [LangKeys.sort_by]: "Sort By",
  [LangKeys.sort_latest_first]: "Latest First",
  [LangKeys.sort_oldest_first]: "Oldest First",
  [LangKeys.sort_highest_amount]: "Highest Amount",
  [LangKeys.sort_lowest_amount]: "Lowest Amount",
  [LangKeys.clear_filters]: "Clear Filters",
  [LangKeys.apply_filters]: "Apply Filters",

  // ADD BILL SCREEN
  [LangKeys.add_bill_sale]: "Sale",
  [LangKeys.add_bill_purchase]: "Purchase",
  [LangKeys.add_bill_expense]: "Expense",
  [LangKeys.add_bill_edit_sale_gst_bill]: "Edit Sale GST Bill",
  [LangKeys.add_bill_sale_gst_bill]: "Sale GST Bill",
  [LangKeys.add_bill_edit_purchase_gst_bill]: "Edit Purchase GST Bill",
  [LangKeys.add_bill_purchase_gst_bill]: "Purchase GST Bill",
  [LangKeys.add_bill_edit_expense]: "Edit Expense",
  [LangKeys.add_bill_expense_title]: "Expense",
  [LangKeys.add_bill_edit_sale_bill]: "Edit Sale Bill",
  [LangKeys.add_bill_sale_bill]: "Sale Bill",
  [LangKeys.add_bill_edit_purchase_bill]: "Edit Purchase Bill",
  [LangKeys.add_bill_purchase_bill]: "Purchase Bill",
  [LangKeys.add_bill_sale_bill_no]: "Sale Bill No.",
  [LangKeys.add_bill_purchase_bill_no]: "Purchase Bill No.",
  [LangKeys.add_bill_expense_no]: "Expense No.",
  [LangKeys.add_bill_update_sale_bill]: "Update Sale Bill",
  [LangKeys.add_bill_generate_sale_bill]: "Generate Sale Bill",
  [LangKeys.add_bill_update_purchase_bill]: "Update Purchase Bill",
  [LangKeys.add_bill_generate_purchase_bill]: "Generate Purchase Bill",
  [LangKeys.add_bill_update_expense]: "Update Expense",
  [LangKeys.add_bill_generate_expense]: "Add Expense",
  [LangKeys.add_bill_select_customer_error]: "Please select a customer",
  [LangKeys.add_bill_add_item_error]: "Please add at least one item",
  [LangKeys.add_bill_updated_successfully]: "Updated successfully",
  [LangKeys.add_bill_saved_successfully]: "Saved successfully",
  [LangKeys.add_bill_failed_to_save]: "Failed to save bill",
  [LangKeys.add_bill_error_occurred]: "Something went wrong",
  [LangKeys.add_bill_bill_to]: "Bill To",
  [LangKeys.add_bill_search_parties]: "Search parties",
  [LangKeys.add_bill_add_new_party]: "Add New Party",
  [LangKeys.add_bill_edit_party_details]: "Edit Party Details",
  [LangKeys.add_bill_items]: "Items",
  [LangKeys.add_bill_enter_items_from_inventory]: "Enter items from inventory",
  [LangKeys.add_bill_add_new_item]: "Add New Item",
  [LangKeys.add_bill_n_items]: "{n} Items",
  [LangKeys.add_bill_edit_or_add_items]: "Edit or add items",
  [LangKeys.add_bill_discount]: "Discount",
  [LangKeys.add_bill_extra_discount]: "Extra Discount",
  [LangKeys.add_bill_item_subtotal]: "Item Subtotal",
  [LangKeys.add_bill_round_off]: "Round Off",
  [LangKeys.add_bill_bill_amount]: "Bill Amount",
  [LangKeys.add_bill_optional_fields]: "Optional Fields",
  [LangKeys.add_bill_printed_on_invoice]: "Printed on invoice",
  [LangKeys.add_bill_custom_fields]: "Custom Fields",
  [LangKeys.add_bill_party_address]: "Party Address",
  [LangKeys.add_bill_your_address]: "Your Address",
  [LangKeys.add_bill_terms_conditions]: "Terms & Conditions",
  [LangKeys.add_bill_private_to_you]: "Private to you",
  [LangKeys.add_bill_add_notes_photos]: "Add notes or photos",
  [LangKeys.add_bill_n_photos_added]: "{n} photos added",
  [LangKeys.add_bill_balance_due]: "Balance Due",
  [LangKeys.cgst]: "CGST",
  [LangKeys.sgst]: "SGST",
  [LangKeys.pending_bill_no]: "Pending Bill No.",
  [LangKeys.add_bill_add_due_to_ledger]: "Add due Balance to Ledger",
  [LangKeys.add_bill_select_supplier_error]: "Please select a supplier",

  // BILL DETAILS SCREEN
  [LangKeys.bill_details_error_id_missing]: "Bill ID is missing",
  [LangKeys.bill_details_failed_to_load]: "Failed to load bill",
  [LangKeys.bill_details_delete_confirmation_title]: "Delete Bill",
  [LangKeys.bill_details_delete_confirmation_content]: "Are you sure you want to delete this bill? Please note that the related cashbook entry will also be deleted.",
  [LangKeys.bill_details_delete_button]: "Delete",
  [LangKeys.bill_details_deleted_successfully]: "Bill deleted successfully",
  [LangKeys.bill_details_failed_to_delete]: "Failed to delete bill",
  [LangKeys.bill_details_generating_pdf]: "Generating PDF",
  [LangKeys.bill_details_share_text]: "Here is your bill",
  [LangKeys.bill_details_failed_to_share]: "Failed to share bill",
  [LangKeys.bill_details_title]: "Bill Details",
  [LangKeys.bill_details_could_not_load]: "Could not load bill details",
  [LangKeys.bill_details_status]: "Status",
  [LangKeys.bill_details_status_pending]: "Pending",
  [LangKeys.bill_details_no_items]: "No items added",
  [LangKeys.bill_details_view_pdf]: "View PDF",

  // EXPENSE DETAILS SCREEN
  [LangKeys.expense_number_prefix]: "Expense #",
  [LangKeys.edit_expense]: "EDIT EXPENSE",
  [LangKeys.delete_expense]: "DELETE EXPENSE",
  [LangKeys.deleting_expense]: "DELETING...",
  [LangKeys.expense_deleted_successfully]: "Expense deleted successfully",
  [LangKeys.failed_to_delete_expense]: "Failed to delete expense",
  [LangKeys.edit_feature_coming_soon]: "Edit feature coming soon!",
  [LangKeys.delete_expense_confirmation]: "Are you sure you want to delete this expense?",

  // INVOICE PREVIEW SCREEN
  [LangKeys.invoice_preview_title]: "Invoice Preview",
  [LangKeys.invoice_preview_generating]: "Generating invoice",
  [LangKeys.invoice_preview_failed]: "Failed to generate invoice",
  [LangKeys.invoice_preview_preparing_print]: "Preparing for print",
  [LangKeys.invoice_preview_failed_print]: "Failed to print",
  [LangKeys.invoice_preview_delete_title]: "Delete Invoice",
  [LangKeys.invoice_preview_delete_content]: "Are you sure you want to delete this invoice? Please note that the related cashbook entry will also be deleted.",
  [LangKeys.invoice_preview_deleted_successfully]: "Invoice deleted successfully",
  [LangKeys.invoice_preview_failed_delete]: "Failed to delete invoice",
  [LangKeys.invoice_preview_theme_premium]: "Premium",
  [LangKeys.invoice_preview_theme_thermal]: "Thermal",
  [LangKeys.invoice_preview_theme_basic]: "Basic",
  [LangKeys.invoice_preview_theme_new]: "New",
  [LangKeys.invoice_preview_download]: "Download Invoice",
  [LangKeys.invoice_preview_share]: "Share Invoice",
  [LangKeys.invoice_preview_print]: "Print Invoice",
  [LangKeys.invoice_preview_create_new]: "Create New",
  [LangKeys.invoice_preview_done]: "Done",

  // PAYMENT DETAILS SCREEN
  [LangKeys.payment_details_title_in]: "Payment In",
  [LangKeys.payment_details_title_out]: "Payment Out",
  [LangKeys.payment_details_share_text]: "Payment details",
  [LangKeys.payment_details_failed_to_share]: "Failed to share payment details",
  [LangKeys.payment_details_adjusted_invoices]: "Adjusted Invoices",

  // SAMPLE INVOICES SCREEN
  [LangKeys.sample_invoice_title]: "Sample",
  [LangKeys.premium_invoice]: "Premium Invoice",
  [LangKeys.thermal_invoice]: "Thermal Invoice",
  [LangKeys.basic_invoice]: "Basic Invoice",
  [LangKeys.use_this_template]: "USE THIS TEMPLATE",

  // ITEM SELECT SHEET
  [LangKeys.item_select_not_enough_stock]: "Not enough stock. Only {availableStock} available.",
  [LangKeys.item_select_no_items_found]: "No items found",
  [LangKeys.item_select_item_discount]: "Item Discount",
  [LangKeys.item_select_final_price]: "Final Price",
  [LangKeys.item_select_gst_rate]: "GST Rate",
  [LangKeys.item_select_item_single]: "Item",
  [LangKeys.item_select_item_plural]: "Items",
  [LangKeys.item_select_continue]: "Continue",
  [LangKeys.item_select_add_items_to_invoice]: "Add items to invoice",
  [LangKeys.item_select_search_created_items]: "Search created items",
  [LangKeys.item_select_add_new]: "ADD NEW",

  // QUICK ADD ITEM DIALOG
  [LangKeys.add_more_details]: "ADD MORE (STOCK, PURCHASE PRICE ETC)",
  [LangKeys.add_item_to_bill]: "Add item to Bill",
  [LangKeys.please_enter_value]: "Please enter a value",
  [LangKeys.please_enter_valid_number]: "Please enter a valid number",

  // CUSTOM FIELDS DIALOG
  [LangKeys.add_bill_custom_fields_subtitle]: "Add upto 5 custom fields (Eg- Serial Number, Batch, IMEI etc)",
  [LangKeys.add_bill_add_new_custom_field]: "ADD NEW CUSTOM FIELD",
  [LangKeys.add_bill_max_custom_fields]: "You can add a maximum of 5 custom fields.",
  [LangKeys.add_bill_custom_field_name_hint]: "Field Name",
  [LangKeys.add_bill_custom_field_value_hint]: "Value",

  // EDIT PRICE DIALOG
  [LangKeys.edit_price_gst_details]: "({cgst}% CGST + {sgst}% SGST; {igst}% IGST)",
  [LangKeys.edit_price_enter_discount_hint]: "Enter Discount",
  [LangKeys.rupee]: "Rupee",
  [LangKeys.percentage]: "Percentage",
  [LangKeys.rate]: "Rate",
  [LangKeys.tax]: "Tax",

  // ADDRESS SCREEN
  [LangKeys.address_business_address_title]: "Business Address",
  [LangKeys.address_flat_building_number]: "Flat / Building Number",
  [LangKeys.address_enter_flat_building_number]: "Please enter Flat/Building Number",
  [LangKeys.address_area_locality]: "Area / Locality",
  [LangKeys.address_enter_area_locality]: "Please enter Area/Locality",
  [LangKeys.address_city]: "City",
  [LangKeys.address_enter_city]: "Please enter city",
  [LangKeys.address_state]: "State",
  [LangKeys.address_enter_state]: "Please enter state",
  [LangKeys.address_pincode]: "Pincode",
  [LangKeys.address_enter_pincode]: "Please enter Pincode",
  [LangKeys.address_invalid_pincode]: "Invalid pincode",

  // PARTY ADDRESS SCREEN
  [LangKeys.party_address_title]: "Customer Address",
  [LangKeys.party_address_billing_address]: "Billing Address",
  [LangKeys.party_address_shipping_same_as_billing]: "Shipping address same as billing",

  // ADD NOTES AND PHOTOS DIALOG
  [LangKeys.add_notes_and_photos_title]: "Add Notes & Photos",
  [LangKeys.add_notes_and_photos_subtitle]: "Add additional details or images",
  [LangKeys.add_notes_and_photos_notes_hint]: "Write notes here",
  [LangKeys.photos_access_permanently_denied]: "Photo access is permanently denied. Please go to app settings to enable it.",
  [LangKeys.photos_access_denied]: "To select a photo, please grant the app permission to access your camera or photos in your device's settings.",
  [LangKeys.open_settings]: "Open Settings",

  // TERMS AND CONDITIONS DIALOG
  [LangKeys.terms_and_conditions_title]: "Terms & Conditions",
  [LangKeys.terms_and_conditions_hint]: "Enter terms and conditions",

  // KHATA TABS
  [LangKeys.customers]: "Customers",
  [LangKeys.suppliers]: "Suppliers",
  [LangKeys.search_supplier]: "Search Supplier",
  [LangKeys.add_first_customer]: "Add your first customer",
  [LangKeys.add_first_supplier]: "Add your first supplier",
  [LangKeys.add_new_customer_prompt]: "No customers added yet. To add a new customer, tap the “+” button above.",
  [LangKeys.add_new_suppliers_prompt]: "No suppliers added yet. To add a new supplier, tap the “+” button above.",

  // CASHBOOK HELP DIALOG
  [LangKeys.cashbook_help_title]: "Cashbook Help",
  [LangKeys.cashbook_help_in_title]: "Cash In (Received)",
  [LangKeys.cashbook_help_in_desc]: "Here you can see the record of all cash amounts received in your business.",
  [LangKeys.cashbook_help_out_title]: "Cash Out (Spent)",
  [LangKeys.cashbook_help_out_desc]: "Here you can see the record of all cash amounts spent from your business.",
  [LangKeys.cashbook_help_total_balance_title]: "Total Balance",
  [LangKeys.cashbook_help_total_balance_desc]: "This shows the current total balance of your cashbook.",
  [LangKeys.cashbook_help_today_balance_title]: "Today's Balance",
  [LangKeys.cashbook_help_today_balance_desc]: "This shows the balance based only on today's cash transactions.",
  [LangKeys.cashbook_help_report_title]: "Cashbook Report",
  [LangKeys.cashbook_help_report_desc]: "From here, you can view and download the cashbook report.",

  // ADD EXPENSE SCREEN
  [LangKeys.expense_amount]: "Expense Amount",
  [LangKeys.select_category]: "Select Category",
  [LangKeys.select_expense_category]: "Select Expense Category",
  [LangKeys.expense_items_warning]: "Expense items will not affect your inventory items.",
  [LangKeys.add_expense_items_optional]: "Add Expense Items (Optional)",
  [LangKeys.expense_items_feature_coming_soon]: "Expense Items feature coming soon!",
  [LangKeys.notes_and_photos_optional]: "Notes & Photos (Optional)",
  [LangKeys.photos_added]: "photos added",
  [LangKeys.save_expense_amount]: "SAVE EXPENSE",
  [LangKeys.update_expense_amount]: "UPDATE EXPENSE",
  [LangKeys.expense_saved_successfully]: "Expense saved successfully",
  [LangKeys.expense_updated_successfully]: "Expense updated successfully",
  [LangKeys.failed_to_save_expense]: "Failed to save expense",
  [LangKeys.enter_valid_amount]: "Please enter a valid amount.",
  [LangKeys.please_select_expense_category]: "Please select an expense category.",
  [LangKeys.category]: "Category",

  // EXPENSE CATEGORIES
  [LangKeys.cat_rent]: "Rent",
  [LangKeys.cat_salaries]: "Salaries / Wages",
  [LangKeys.cat_electricity]: "Electricity",
  [LangKeys.cat_water]: "Water Bill",
  [LangKeys.cat_internet]: "Telephone / Internet",
  [LangKeys.cat_office]: "Office Expenses",
  [LangKeys.cat_marketing]: "Marketing / Ads",
  [LangKeys.cat_travel]: "Travel",
  [LangKeys.cat_fuel]: "Fuel / Petrol",
  [LangKeys.cat_food]: "Food /Refreshments",
  [LangKeys.cat_repairs]: "Repairs & Maintenance",
  [LangKeys.cat_election]: "Election Expenses",
  [LangKeys.cat_taxes]: "Taxes / GST",
  [LangKeys.cat_insurance]: "Insurance",
  [LangKeys.cat_cleaning]: "Cleaning",
  [LangKeys.cat_delivery]: "Delivery / Shipping",
  [LangKeys.cat_software]: "Software / Apps",
  [LangKeys.cat_furniture]: "Furniture",
  [LangKeys.cat_other]: "Other",

  // EXPENSE EMPTY STATE
  [LangKeys.expense_empty_title]: "Manage your expenses easily",
  [LangKeys.expense_empty_subtitle]: "Track all your business expenses in one place.",
  [LangKeys.expense_empty_footer]: "All expenses are automatically added to the cashbook.",

  // BILL REPORT SCREEN
  [LangKeys.bill_report_title]: "Bill Report",
  [LangKeys.report_for_period]: "Report for Period",
  [LangKeys.select_date_range]: "Select Date Range",
  [LangKeys.total_sales]: "Total Sales",
  [LangKeys.total_purchases]: "Total Purchases",
  [LangKeys.total_expenses]: "Total Expenses",
  [LangKeys.net_profit]: "Net Profit",
  [LangKeys.net_loss]: "Net Loss",
  [LangKeys.all_transactions]: "All Transactions",
  [LangKeys.no_transactions_found_period]: "No Transactions Found for This Period",
  [LangKeys.expense_fallback_category]: "Other Expense",

  // SALES REPORT SCREEN
  [LangKeys.sales_report]: "Sales Report",
  [LangKeys.transactions]: "Transactions",
  [LangKeys.net_sale]: "Net Sale",
  [LangKeys.unpaid_balance]: "Unpaid Balance",
  [LangKeys.sales_report_share_text]: "Here is your Sales Report summary.",

  // PURCHASE REPORT SCREEN
  [LangKeys.purchase_report]: "Purchase Report",
  [LangKeys.net_purchase]: "Net Purchase",
  [LangKeys.purchase_report_share_text]: "Here is your Purchase Report summary.",

  // KHATA FILTER & SORT
  [LangKeys.filter_by_balance]: "Filter by Balance",
  [LangKeys.filter_all_parties]: "All Parties",

  // LOGOUT
  [LangKeys.logout_confirm]: "Are you sure you want to logout?",
  [LangKeys.confirm_logout]: "Logout",

  // DEVICES
  [LangKeys.manage_devices]: "Manage Devices",
  [LangKeys.active_devices]: "Active Devices",
  [LangKeys.logout_device]: "Logout Device",
  [LangKeys.logout_device_confirm]: "Are you sure you want to logout this device?",
  [LangKeys.device_logged_out]: "Device logged out successfully",
  [LangKeys.no_active_devices]: "No active devices",
  [LangKeys.last_login]: "Last login",
  [LangKeys.this_device]: "This Device",
  [LangKeys.loading_devices]: "Loading devices...",

  // SMS SETTINGS
  [LangKeys.send_whatsapp_messages]: "Send WhatsApp Messages",
  [LangKeys.enabled]: "Enabled",
  [LangKeys.disabled]: "Disabled",
  [LangKeys.manage_whatsapp_settings]: "Manage WhatsApp SMS Settings",
  [LangKeys.recharge_and_control]: "Recharge credits and control messaging",
  [LangKeys.wa_message_sent]: "Message Sent",
  [LangKeys.wa_message_pending]: "Message Pending",
  [LangKeys.wa_message_disabled]: "Message Disabled",
  [LangKeys.wa_message_failed]: "Message failed to send",
  [LangKeys.wa_no_credits]: "No credits, message not sent",

  // DASHBOARD EMPTY STATE
  [LangKeys.pro_tip]: "PRO TIP",
  [LangKeys.dashboard_empty_tip]: "Click on any entry on the left to see full details, edit or share with customers.",
  [LangKeys.select_entry]: "Select Entry",
  [LangKeys.entry_details_appear]: "Entry details will appear here",

  // PREMIUM
  [LangKeys.plan_standard_name]: "Standard (Ads Free)",
  [LangKeys.plan_ads_free_name]: "Ads Free +",
  [LangKeys.plan_premium_name]: "Premium",
  [LangKeys.plan_recommended_tag]: "Recommended Plan",
  [LangKeys.plan_duration_30_days]: "for 30 Days",
  [LangKeys.plan_duration_180_days]: "for 180 Days (6 Months)",
  [LangKeys.plan_duration_365_days]: "for 365 Days (1 Year)",
  [LangKeys.plan_duration_30_days_badge]: "30 Days",
  [LangKeys.plan_save_20_percent]: "Save ~20%",
  [LangKeys.plan_best_value_badge]: "Best Value",
  [LangKeys.plan_best_value_plan_tag]: "Best Value Plan",
  [LangKeys.plan_most_popular_save]: "Most Popular • Save ₹{amount}",
  [LangKeys.plan_save_amount_tag]: "Save ₹{amount}",
  [LangKeys.duration_1_month]: "1 Month",
  [LangKeys.duration_6_months]: "6 Months",
  [LangKeys.duration_12_months]: "12 Months",
  [LangKeys.plan_save_text]: "Save",
  [LangKeys.benefit_no_ads]: "Ad-free experience (100% Ads Free)",
  [LangKeys.benefit_support]: "24/7 Priority Customer Support",
  [LangKeys.benefit_all_ads_free]: "All benefits of Ads Free+ Plan",
  [LangKeys.benefit_multiple_devices]: "Multiple device login together",
  [LangKeys.benefit_desktop_access]: "Access on computer/desktop",
  [LangKeys.benefit_create_bills]: "Create bills (Normal, GST Bills)",
  [LangKeys.benefit_defaulters_list]: "View Defaulters list in one click",
  [LangKeys.benefit_organize_lists]: "Organize accounts with lists",
  [LangKeys.benefit_manage_stocks]: "Manage stocks (items with transactions)",
  [LangKeys.benefit_financial_reports]: "Premium financial reports (PDF/Excel)",
  [LangKeys.benefit_dual_backup]: "Secure local and cloud storage backup",
  [LangKeys.benefit_unlimited_entry]: "Unlimited entries in Cashbook/Khata",
  [LangKeys.benefit_unlimited_transactions]: "Unlimited Transactions",
  [LangKeys.benefit_unlimited_sms]: "Unlimited transaction SMS",
  [LangKeys.benefit_dairy_management]: "Dairy Features (Milk Record, Rate Chart, Bills)",
  [LangKeys.benefit_refer_earn]: "Refer & Earn (Free Recharge Validity)",
  [LangKeys.my_subscription_title]: "My Subscription",
  [LangKeys.premium_plans_title]: "Our Premium Plans",
  [LangKeys.active_badge_label]: "Active",
  [LangKeys.expires_on_label]: "Expires on {date}",
  [LangKeys.expired_badge_label]: "Expired",
  [LangKeys.expired_on_label]: "Expired on {date}",
  [LangKeys.extend_plan_label]: "Extend Plan (+{days} Days)",
  [LangKeys.days_remaining_label]: "({days} Days Left)",
  [LangKeys.secure_checkout_label]: "100% Safe & Secure SSL Checkout",
  [LangKeys.upgrade_button]: "Upgrade",
  [LangKeys.downgrade_button]: "Downgrade Plan",




  // REPORTS DASHBOARD
  [LangKeys.business_reports]: "Business Reports",
  [LangKeys.business_reports_desc]: "Analysis and insights for your business",
  [LangKeys.ledger_cashbook_reports]: "Ledger & Cashbook Reports",
  [LangKeys.billing_inventory_reports]: "Billing & Inventory Reports",
  [LangKeys.customer_ledger_statement_report]: "Customer Ledger Statement",
  [LangKeys.customer_ledger_report_desc]: "Detailed transaction history and balance statement of customers",
  [LangKeys.supplier_ledger_statement_report]: "Supplier Ledger Statement",
  [LangKeys.supplier_ledger_report_desc]: "Detailed transaction history and balance statement of suppliers",
  [LangKeys.cashbook_report_desc]: "Daily summary statement of cash and online transactions",
  [LangKeys.sales_report_desc]: "Bill-wise sales summary, total sales and unpaid balance details",
  [LangKeys.purchase_report_desc]: "Bill-wise purchase records and summaries",
  [LangKeys.bills_summary_report]: "Bills Summary Report",
  [LangKeys.bills_summary_report_desc]: "Complete analytics of sales, purchases and profit/loss",
  [LangKeys.item_stock_sales_report]: "Item Stock & Sales Report",
  [LangKeys.item_stock_sales_report_desc]: "Stock status and sales summary of products and services",
  [LangKeys.select_party]: "Select Party",
  [LangKeys.search_placeholder]: "Search by name or mobile...",
  [LangKeys.back_to_dashboard]: "Go to Reports Menu",
  [LangKeys.loading_report_data]: "Loading report...",
  [LangKeys.no_parties_found]: "No parties found.",
  [LangKeys.select_customer]: "Select a customer to view the report",
  [LangKeys.select_supplier]: "Select a supplier to view the report",
  [LangKeys.premium_feature]: "Premium Feature",
  [LangKeys.premium_lock_desc]: "Unlock professional billing, sales/purchase invoice reports, daybook statements, and inventory summaries.",
  [LangKeys.upgrade_to_premium]: "Upgrade to Ads Free+ / Premium 🚀",

  // Business Profile & Marketplace
  [LangKeys.biz_profile__marketplace_settings]: 'Online Store Settings (Moxpal Market)',
  [LangKeys.biz_profile__online_business_toggle]: 'Keep Online Business Active',
  [LangKeys.biz_profile__online_business_active]: 'Business is Active Online (Active)',
  [LangKeys.biz_profile__online_business_offline]: 'Business is Offline (Hidden)',
  [LangKeys.biz_profile__gps_pending_badge]: 'Online Active (Set GPS)',
  [LangKeys.biz_profile__online_business_sub_active]: 'After turning on, 1-click autofill State, City, Area, Pincode and GPS Location so nearby customers can discover your shop.',
  [LangKeys.biz_profile__online_business_sub_offline]: 'Turn on online business so nearby customers can discover your products and services in the Local Market.',
  [LangKeys.biz_profile__know_benefits_btn]: '💡 Know Benefits & Rules',
  [LangKeys.biz_profile__benefits_modal_title]: 'Online Business Benefits & Information',
  [LangKeys.biz_profile__benefits_step1_title]: '1. What happens when you turn this on?',
  [LangKeys.biz_profile__benefits_step1_desc]: 'Your business, products and services immediately go live in Moxpal Local Market. Nearby customers can discover you and connect directly.',
  [LangKeys.biz_profile__benefits_step2_title]: '2. What do you need to do?',
  [LangKeys.biz_profile__benefits_step2_desc]: '• Use the blue button (⚡ 1-Click) to autofill State, District, Area, Pincode and GPS.\n• Add your products or services so customers can see your catalog.',
  [LangKeys.biz_profile__benefits_step3_title]: '3. What benefits do you get?',
  [LangKeys.biz_profile__benefits_step3_desc]: '• 0% Commission (100% Free) — No middleman.\n• Direct WhatsApp and phone call orders from customers.\n• 24/7 Open Digital Store — customers can view your shop anytime.\n• Grow your brand awareness and local sales across the region.',
  [LangKeys.biz_profile__benefits_btn_got_it]: 'Got it, thanks 👍',
  [LangKeys.biz_profile__autofill_btn_title]: '⚡ 1-Click Full Address Auto-fill',
  [LangKeys.biz_profile__autofill_btn_sub]: 'Auto-fill State, City, Area, Pincode & GPS from location',
  [LangKeys.biz_profile__autofill_searching]: 'Detecting location...',
  [LangKeys.biz_profile__state_lbl]: 'State',
  [LangKeys.biz_profile__state_add]: 'Add State',
  [LangKeys.biz_profile__state_placeholder]: 'e.g. Rajasthan, Gujarat, Maharashtra...',
  [LangKeys.biz_profile__city_lbl]: 'City / District',
  [LangKeys.biz_profile__city_add]: 'Add City',
  [LangKeys.biz_profile__city_placeholder]: 'e.g. Bikaner, Jaipur, Mumbai...',
  [LangKeys.biz_profile__area_lbl]: 'Area / Village / Town',
  [LangKeys.biz_profile__area_add]: 'Add Area/Village',
  [LangKeys.biz_profile__area_placeholder]: 'e.g. Sadhasar, Nokha, Sadar Bazar...',
  [LangKeys.biz_profile__pincode_lbl]: 'Pincode',
  [LangKeys.biz_profile__pincode_add]: 'Add Pincode',
  [LangKeys.biz_profile__pincode_placeholder]: 'Enter 6-digit Pincode',
  [LangKeys.biz_profile__tagline_lbl]: 'Business Tagline / Description',
  [LangKeys.biz_profile__tagline_add]: 'Add Tagline',
  [LangKeys.biz_profile__tagline_placeholder]: 'e.g. Best quality products & fastest delivery guaranteed',
  [LangKeys.biz_profile__gps_lbl]: 'Business GPS Location',
  [LangKeys.biz_profile__gps_not_set]: 'GPS Location Not Set',
  [LangKeys.biz_profile__gps_update_btn]: 'Update GPS',
  [LangKeys.biz_profile__gps_get_btn]: 'Get GPS Location',
  [LangKeys.biz_profile__gps_searching]: 'Searching...',
  [LangKeys.biz_profile__gps_live_warning]: '⚠️ Store is online but GPS location is not set! Click ⚡ 1-Click button to set GPS so nearby customers can discover your shop.',
  [LangKeys.biz_profile__gps_turn_on_toast]: 'Please enable GPS / Location in your browser/device',
  [LangKeys.biz_profile__gps_permission_denied_toast]: 'Location permission was denied',
  [LangKeys.biz_profile__gps_permission_settings_toast]: 'Please enable Location Permission in browser settings',
  [LangKeys.biz_profile__gps_autofill_success_toast]: 'Full address (State, City, Area, Pincode & GPS) auto-filled successfully!',
  [LangKeys.biz_profile__gps_error_toast]: 'Error fetching location',
  [LangKeys.biz_market_video_guide_title]: 'How to take your shop online on Local Market?',
  [LangKeys.biz_market_video_guide_sub]: 'Watch 1-minute video guide • YouTube Guide',
  [LangKeys.item_video_guide_btn_sub]: "Guide to activate store & products online",
  [LangKeys.service_video_guide_btn_sub]: "Guide to list services & shop online",
  [LangKeys.item_marketplace_title]: "Online Marketplace",
  [LangKeys.item_marketplace_sub_active]: "This product will be visible online to nearby customers; they can contact you directly and order via WhatsApp.",
  [LangKeys.item_marketplace_sub_inactive]: "This product will only remain in your private ledger.",
  [LangKeys.service_marketplace_sub_active]: "This service will be visible online to nearby customers; they can contact you directly and book via WhatsApp/Call.",
  [LangKeys.service_marketplace_sub_inactive]: "This service will only remain in your private business account.",
  [LangKeys.item_category_lbl]: "Category",
  [LangKeys.change_btn]: "Change",
  [LangKeys.item_discount_price_lbl]: "Offer / Discount Price (₹) (Optional)",
  [LangKeys.item_discount_price_hint]: "e.g. 450",
  [LangKeys.service_discount_price_lbl]: "Offer / Discount Service Charge (₹) (Optional)",
  [LangKeys.service_discount_price_hint]: "e.g. 750",
  [LangKeys.item_desc_lbl]: "Short Description (Optional)",
  [LangKeys.item_desc_hint]: "Enter product brand, model, color, size & key features (helps in Google Search)...",
  [LangKeys.service_desc_lbl]: "Service Description (Optional)",
  [LangKeys.service_desc_hint]: "Enter service features, work process & expertise (helps in Google Search)...",
  [LangKeys.market_seo_badge]: "Google SEO & Ranking",
  [LangKeys.category_picker_title]: "Select Category",
  [LangKeys.category_picker_sub_item]: "Which category does this item belong to?",
  [LangKeys.category_picker_sub_service]: "Which category does this service belong to?",
  [LangKeys.category_search_hint]: "Search category (e.g. Grocery, Dairy, Clothes...)",
  [LangKeys.no_category_found]: "No category found",
  [LangKeys.nothing_found_for]: "Nothing found for",
  [LangKeys.cat_title_general]: "General Products",
  [LangKeys.cat_sub_general]: "General merchandise & products",
  [LangKeys.cat_title_grocery]: "Grocery & Provisions",
  [LangKeys.cat_sub_grocery]: "Kirana, food grains & essentials",
  [LangKeys.cat_title_dairy]: "Dairy & Milk Products",
  [LangKeys.cat_sub_dairy]: "Milk, curd, ghee & paneer",
  [LangKeys.cat_title_fruits_veg]: "Fruits & Vegetables",
  [LangKeys.cat_sub_fruits_veg]: "Fresh farm fruits & veggies",
  [LangKeys.cat_title_sweets_bakery]: "Sweets & Bakery",
  [LangKeys.cat_sub_sweets_bakery]: "Mithai, snacks, cakes & bakery",
  [LangKeys.cat_title_restaurant_food]: "Restaurant & Food",
  [LangKeys.cat_sub_restaurant_food]: "Hotel, restaurant & fast food",
  [LangKeys.cat_title_pharmacy_medical]: "Pharmacy & Healthcare",
  [LangKeys.cat_sub_pharmacy_medical]: "Medicines & health products",
  [LangKeys.cat_title_agriculture_seeds]: "Agriculture & Seeds",
  [LangKeys.cat_sub_agriculture_seeds]: "Fertilizers, seeds & pesticides",
  [LangKeys.cat_title_animal_feed]: "Animal & Cattle Feed",
  [LangKeys.cat_sub_animal_feed]: "Churi, khal & animal nutrition",
  [LangKeys.cat_title_electronics_mobile]: "Electronics & Mobiles",
  [LangKeys.cat_sub_electronics_mobile]: "Smartphones, laptops & IT accessories",
  [LangKeys.cat_title_electrical_appliances]: "Electricals & Appliances",
  [LangKeys.cat_sub_electrical_appliances]: "Home appliances, lights & fans",
  [LangKeys.cat_title_clothing_garments]: "Clothing & Garments",
  [LangKeys.cat_sub_clothing_garments]: "Men, women & kids fashion",
  [LangKeys.cat_title_footwear_shoes]: "Footwear & Shoes",
  [LangKeys.cat_sub_footwear_shoes]: "Shoes, sandals & slippers",
  [LangKeys.cat_title_hardware_sanitary]: "Hardware & Sanitary",
  [LangKeys.cat_sub_hardware_sanitary]: "Tools, pipes & bathroom fittings",
  [LangKeys.cat_title_building_materials]: "Building Materials",
  [LangKeys.cat_sub_building_materials]: "Cement, sand, bricks & steel",
  [LangKeys.cat_title_automobile_parts]: "Automobile & Spares",
  [LangKeys.cat_sub_automobile_parts]: "Car & bike spare parts",
  [LangKeys.cat_title_cosmetics_beauty]: "Cosmetics & Beauty",
  [LangKeys.cat_sub_cosmetics_beauty]: "Skincare, makeup & salon goods",
  [LangKeys.cat_title_stationery_books]: "Books & Stationery",
  [LangKeys.cat_sub_stationery_books]: "School supplies, books & printing",
  [LangKeys.cat_title_jewellery_gifts]: "Jewellery & Gifts",
  [LangKeys.cat_sub_jewellery_gifts]: "Gold, silver & gift articles",
  [LangKeys.cat_title_furniture_decor]: "Furniture & Decor",
  [LangKeys.cat_sub_furniture_decor]: "Home & office furniture",
  [LangKeys.cat_title_kitchenware_utensils]: "Kitchenware & Utensils",
  [LangKeys.cat_sub_kitchenware_utensils]: "Cookware & kitchen items",
  [LangKeys.cat_title_toys_sports]: "Toys & Sports",
  [LangKeys.cat_sub_toys_sports]: "Games, kids toys & sports gear",
  [LangKeys.cat_title_packaging_disposable]: "Packaging & Disposables",
  [LangKeys.cat_sub_packaging_disposable]: "Plastic containers & packaging",
  [LangKeys.cat_title_tailoring_boutique]: "Tailoring & Boutique",
  [LangKeys.cat_sub_tailoring_boutique]: "Custom clothing & boutique items",
  [LangKeys.cat_title_meat_poultry]: "Meat & Poultry",
  [LangKeys.cat_sub_meat_poultry]: "Fresh meat, fish & chicken",
  [LangKeys.cat_title_services_repair]: "Repair & Services",
  [LangKeys.cat_sub_services_repair]: "Technical & repair services",
  [LangKeys.cat_title_other]: "Other Products & Services",
  [LangKeys.cat_sub_other]: "All other items and goods",
  [LangKeys.cat_title_optical_eyewear]: "Optical & Eyewear",
  [LangKeys.cat_sub_optical_eyewear]: "Glasses, Frames & Lenses",
  [LangKeys.cat_title_pooja_religious]: "Pooja Items & Essentials",
  [LangKeys.cat_sub_pooja_religious]: "Incense, Diyas & Hawan Samagri",
  [LangKeys.cat_title_watches_accessories]: "Watches & Accessories",
  [LangKeys.cat_sub_watches_accessories]: "Wristwatches, Smartwatches & Belts",
  [LangKeys.cat_title_generalservice]: "General Service",
  [LangKeys.cat_sub_generalservice]: "All general services & labor",
  [LangKeys.cat_title_electronics_tv_repair]: "TV & Electronics Repair",
  [LangKeys.cat_sub_electronics_tv_repair]: "TV, LED, music systems & sound",
  [LangKeys.cat_title_ac_appliances_repair]: "AC & Appliance Repair",
  [LangKeys.cat_sub_ac_appliances_repair]: "AC, fridge, washing machine & geyser",
  [LangKeys.cat_title_electrician_wiring]: "Electrician & Wiring",
  [LangKeys.cat_sub_electrician_wiring]: "Wiring, fitting & motor rewinding",
  [LangKeys.cat_title_plumbing_sanitary]: "Plumber & Sanitary",
  [LangKeys.cat_sub_plumbing_sanitary]: "Pipeline, taps & drainage fittings",
  [LangKeys.cat_title_tailoring_stitching]: "Tailoring & Stitching",
  [LangKeys.cat_sub_tailoring_stitching]: "Tailoring, alterations & boutique",
  [LangKeys.cat_title_mobile_laptop_repair]: "Mobile & Laptop Repair",
  [LangKeys.cat_sub_mobile_laptop_repair]: "Smartphone, PC & laptop service",
  [LangKeys.cat_title_automobile_mechanic]: "Vehicle Mechanic & Washing",
  [LangKeys.cat_sub_automobile_mechanic]: "Car, bike repair & wash services",
  [LangKeys.cat_title_beauty_parlour_salon]: "Beauty Parlour & Salon",
  [LangKeys.cat_sub_beauty_parlour_salon]: "Haircut, facial & bridal makeup",
  [LangKeys.cat_title_carpenter_woodwork]: "Carpenter & Woodwork",
  [LangKeys.cat_sub_carpenter_woodwork]: "Furniture repair & woodworking",
  [LangKeys.cat_title_painting_whitewash]: "Painting & Whitewash",
  [LangKeys.cat_sub_painting_whitewash]: "Wall paint, putty & polishing",
  [LangKeys.cat_title_construction_civil]: "Construction & Masonry",
  [LangKeys.cat_sub_construction_civil]: "Contractor, mason & construction labor",
  [LangKeys.cat_title_agri_motor_tractor]: "Tractor & Pump Repair",
  [LangKeys.cat_sub_agri_motor_tractor]: "Tractor servicing & water pump repair",
  [LangKeys.cat_title_cctv_security_install]: "CCTV & Security Setup",
  [LangKeys.cat_sub_cctv_security_install]: "Camera setup & security systems",
  [LangKeys.cat_title_cleaning_pest_control]: "Cleaning & Pest Control",
  [LangKeys.cat_sub_cleaning_pest_control]: "Deep cleaning & pest elimination",
  [LangKeys.cat_title_transport_loading]: "Transport & Logistics",
  [LangKeys.cat_sub_transport_loading]: "Goods transport, loading & shifting",
  [LangKeys.cat_title_photography_video]: "Photography & Video",
  [LangKeys.cat_sub_photography_video]: "Photo shoots, video & studio work",
  [LangKeys.cat_title_events_catering_tent]: "Events & Catering",
  [LangKeys.cat_sub_events_catering_tent]: "Tent house, catering & DJ sound",
  [LangKeys.cat_title_education_tuition]: "Education & Tuition",
  [LangKeys.cat_sub_education_tuition]: "Coaching, home tuition & courses",
  [LangKeys.cat_title_ca_tax_csc_emitra]: "CA, Tax & CSC E-Mitra",
  [LangKeys.cat_sub_ca_tax_csc_emitra]: "Tax filing, CSC, e-mitra & forms",
  [LangKeys.cat_title_healthcare_clinic_lab]: "Doctor & Medical Clinic",
  [LangKeys.cat_sub_healthcare_clinic_lab]: "Doctor visits, tests & home nursing",
  [LangKeys.cat_title_other_service]: "Other Skilled Services",
  [LangKeys.cat_sub_other_service]: "All other technical & expert services",
  [LangKeys.cat_title_transport_taxi]: "Taxi & Tour Travels",
  [LangKeys.cat_sub_transport_taxi]: "Cab Booking & Outstation Trips",
  [LangKeys.cat_title_legal_advocate]: "Legal & Advocate Services",
  [LangKeys.cat_sub_legal_advocate]: "Advocate, Notary & Documentation",
  [LangKeys.cat_title_packers_movers]: "Packers & Movers",
  [LangKeys.cat_sub_packers_movers]: "House & Office Shifting",
  [LangKeys.cat_title_printing_flex_banner]: "Printing Press & Flex Banner",
  [LangKeys.cat_sub_printing_flex_banner]: "Flex Boards, Visiting Cards & DTP",
  [LangKeys.cat_title_gym_fitness_yoga]: "Gym, Fitness & Yoga Trainer",
  [LangKeys.cat_sub_gym_fitness_yoga]: "Gym, Fitness Center & Yoga",
  [LangKeys.cat_title_cook_maid_househelp]: "Cook & Maid Domestic Help",
  [LangKeys.cat_sub_cook_maid_househelp]: "Home Cook, Maid & Housekeeping",
  [LangKeys.item_photo_guide_verified]: "Photo Added • Tier-1 Top Listing",
  [LangKeys.item_photo_guide_why_add]: "Why Add Photo? (5x More Sales)",
  [LangKeys.service_photo_guide_why_add]: "Why Add Photo? (5x More Bookings)",
  [LangKeys.item_photo_guide_desc]: "Add clear PNG/JPG photos. Products with photos rank at the top (Tier-1) in the local marketplace.",
  [LangKeys.service_photo_guide_desc]: "Add clear PNG/JPG photos of your work, tools, or shop. Services with photos rank at the top (Tier-1).",
  [LangKeys.item_video_guide_btn_title]: "Learn Online Listing (5 Min Video)",
  [LangKeys.service_video_guide_btn_title]: "Learn Service Listing (5 Min Video)",
  [LangKeys.market_format_bold]: "𝗕 Bold (*text*)",
  [LangKeys.market_format_bullet]: "• Bullet Point",
  [LangKeys.market_format_highlight]: "⭐ Highlights",
  [LangKeys.market_format_warranty_item]: "📦 Warranty / Specs",
  [LangKeys.market_format_warranty_service]: "📦 Warranty / Guarantee",
  [LangKeys.market_format_template_item]: "⚡ Pro Blog Template",
  [LangKeys.market_format_template_service]: "⚡ Pro Service Template",
  [LangKeys.market_seo_tip_item]: "Adding detailed description helps rank your product on Google Search & attract more local buyers.",
  [LangKeys.market_seo_tip_service]: "Adding detailed description helps rank your service on Google Search & attract more local clients.",
  [LangKeys.crop_photo_title]: "Crop & Adjust Photo",
  [LangKeys.crop_product_photo]: "Crop Product Photo",
  [LangKeys.crop_service_photo]: "Crop Service Photo",
  [LangKeys.crop_drag_hint]: "Drag image to reposition",
  [LangKeys.crop_rotate_left]: "90° Left",
  [LangKeys.crop_rotate_right]: "90° Right",
  [LangKeys.crop_reset]: "Reset",
  [LangKeys.crop_ratio_square]: "1:1 (Square)",
  [LangKeys.crop_ratio_standard]: "4:3 (Standard)",
  [LangKeys.crop_ratio_free]: "Free",
  [LangKeys.crop_save_done]: "Crop & Save (Done)",
  [LangKeys.crop_compressing]: "Compressing...",
  [LangKeys.party_or_details]: "Party / Details",
  [LangKeys.report_copied_clipboard]: "Report summary copied to clipboard!",
  [LangKeys.party]: "Party",
  [LangKeys.sale]: "Sale",
  [LangKeys.purchase]: "Purchase",
  [LangKeys.expense]: "Expense",
  [LangKeys.ai_support_btn]: "Chat with AI Support (24x7 Live)",
  [LangKeys.ai_support_title]: "Moxpal AI Support",
  [LangKeys.ai_support_online_status]: "● 24x7 Instant Support",
  [LangKeys.ai_support_welcome_msg]: "Hello! 🙏 I am the smart AI assistant for *Moxpal Khata*.\\n\\nI am ready to help you with your ledger, billing, dairy passbook, or subscription plans. How can I assist you today?",
  [LangKeys.ai_support_input_hint]: "Ask your question or issue here...",
  [LangKeys.ai_support_typing]: "AI assistant is typing...",
  [LangKeys.ai_support_copied]: "Message copied to clipboard",
  [LangKeys.ai_support_net_error]: "Network connection error. Please check your internet or retry.",
  [LangKeys.ai_support_server_error]: "Unable to connect to server. Please try again or contact us on WhatsApp (+91 9929371541).",
  [LangKeys.ai_support_sugg_plan]: "💎 What are the premium plan benefits?",
  [LangKeys.ai_support_sugg_dairy]: "🥛 How to use Dairy Passbook?",
  [LangKeys.ai_support_sugg_party]: "👥 How to add a new customer/account?",
  [LangKeys.ai_support_sugg_backup]: "💾 How to backup my data?",
  [LangKeys.ai_support_sugg_bill]: "🧾 How to create a new bill or invoice?",
  [LangKeys.ai_support_clear_chat]: "Start New Chat",
  [LangKeys.ai_support_clear_title]: "Clear Chat History?",
  [LangKeys.ai_support_clear_confirm]: "Do you want to clear past conversation and start a new chat?",
  [LangKeys.help_center_title]: "Moxpal Khata Help Center",
  [LangKeys.help_center_sub]: "Your one-stop destination for FAQs, tutorials & customer support",
  [LangKeys.help_support_title]: "Help & Support",
  [LangKeys.help_center_heading]: "Moxpal Khata Help Center",
  [LangKeys.help_center_subheading]: "Your one-stop destination for FAQs, tutorials & customer support",
  [LangKeys.help_ai_title]: "Moxpal AI Support",
  [LangKeys.help_ai_live_badge]: "24x7 LIVE",
  [LangKeys.help_ai_online_status]: "• 24x7 Instant Support",
  [LangKeys.help_ai_desc]: "Get instant AI solutions for khata, billing, inventory, dairy passbook, or plans.",
  [LangKeys.help_ai_chat_btn]: "Chat with AI Support (24x7 Live)",
  [LangKeys.help_whatsapp_title]: "Contact Us (WhatsApp)",
  [LangKeys.help_whatsapp_sub]: "+91 99293 71541 • Official Support Team",
  [LangKeys.help_call_title]: "Call Helpline",
  [LangKeys.help_call_number]: "+91 9166277283",
  [LangKeys.help_email_title]: "Email Support",
  [LangKeys.help_email_id]: "support@moxpal.com",
  [LangKeys.help_faq_title]: "Frequently Asked Questions (FAQs)",
  [LangKeys.help_faq_1_q]: "How to add a new customer or supplier in Khata?",
  [LangKeys.help_faq_1_a]: "Tap \"Add Customer\" button on home screen, enter name and mobile number, then save.",
  [LangKeys.help_faq_2_q]: "How to record milk collection in Dairy Passbook?",
  [LangKeys.help_faq_2_a]: "Open Dairy section, tap \"Milk Entry\", enter FAT/SNF or direct rate and send slip in 1-click.",
  [LangKeys.help_faq_3_q]: "How is data backup kept secure?",
  [LangKeys.help_faq_3_a]: "All your business data on Moxpal Khata is 100% encrypted and secured on cloud servers.",
  [LangKeys.help_faq_4_q]: "How to upgrade subscription plan?",
  [LangKeys.help_faq_4_a]: "Go to Settings > \"My Subscription\", choose your preferred plan and make a secure payment.",
  [LangKeys.help_footer_call_hours]: "Call Support: Mon - Sat (9:00 AM to 8:00 PM)",
  [LangKeys.help_footer_ai_hours]: "AI Chat Assistant: 24 Hours 365 Days Instant Support",
  [LangKeys.help_footer_branding]: "Moxpal Technologies • 100% Secure & Reliable • Made in India 🇮🇳",
  [LangKeys.help_feature_launch_error]: "Unable to open service",
};

export default en;